import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { EDITOR_COLORS, editorText } from '../../../styles/editorTheme';

export const NodesView: React.FC = () => {
  return (
    <View style={styles.panel}>
      <View style={styles.placeholderCard}>
        <Text style={styles.placeholderTitle}>Nodes</Text>
        <Text style={styles.placeholderText}>
          Node graph editor — coming soon.
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  panel: {
    padding: 20,
  },
  placeholderCard: {
    backgroundColor: EDITOR_COLORS.background,
    borderRadius: 12,
    padding: 20,
  },
  placeholderTitle: {
    ...editorText,
    color: EDITOR_COLORS.textPrimary,
    marginBottom: 8,
  },
  placeholderText: {
    ...editorText,
    color: EDITOR_COLORS.textMuted,
    lineHeight: 20,
  },
});
